import styled from "styled-components";
import { themevals as theme, themevals } from "theme/themevals";
import { bp } from "theme/themevals";

interface CustomProps {
  $mt?: string;
}

export const PageWrapper = styled.div`
  background: #ffffff;
  width: 100%;
  min-height: 100%;
  flex-grow: 1;
  display: grid;
  grid-template-columns: 250px 1fr;  
  @media (max-width: ${bp.lg})  {      
    grid-template-columns: 1fr;
    overflow-x: hidden;
  }
`;

export const PageContent = styled.div`
  width: 100%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 2;  
`;

export const NavWrapper = styled.div`
  position: relative; 
  z-index: 1; 
  min-height: 100%;
  background-color: #000;
  border-right: 1px solid ${theme.colors.base_300};
  box-shadow: 4px 0px 8px 0px rgba(113, 125, 150, 0.05);
  display: flex;
  flex-direction: column;
  
  & .navbar-toggle {cursor: pointer; display: none; content: ""; position: absolute; top: 23px; right: -20px; width: 20px; height: 20px; background-color: ${theme.colors.base_800}; border: 2px solid ${theme.colors.base_800}; transition: all 150ms ease-in;}
  & .navbar-toggle:before {content: ""; display: block; height: 2px; width: calc(100% - 4px); background: ${theme.colors.white}; position: absolute; top: calc(50% - 2px); left: 2px;  transform: rotate(-90deg); transition: all 150ms ease-in;}
  & .navbar-toggle:after {content: ""; display: block; height: 2px; width: calc(100% - 4px); background: ${theme.colors.white}; position: absolute; top: calc(50% - 2px); left: 2px;transition: all 150ms ease-in;}
  .navbar-open & .navbar-toggle:before {transform: rotate(-45deg);}
  .navbar-open & .navbar-toggle:after {transform: rotate(45deg);}

  @media (max-width: ${bp.lg})  {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    z-index: 1050;
    width: 250px; 
    min-width: 250px;
    max-width: calc(100% - 25px);
    min-height: 100vh;
    transition: transform 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1);
    transform: translate3d(-100%, 0, 0);
    & .navbar-toggle {display: block; }
    .navbar-open & { transform: translate3d(0, 0, 0); }
  }
`;

export const NavInner = styled.div`
  height: 100vh;
  width: 100%;
  position: sticky;
  top: 0;  
  display: flex;
  flex-direction: column;  
`;

export const NavInnerMenu = styled.div`
  overflow: auto;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  margin-top:40px;
  padding-left:20px;
  padding-right:20px;
`;

export const NavToggle = styled.div`
  display: none;
  @media (max-width: 991px)  {
    display: block;
    margin-left: auto;
  }
`;

export const ToggleButton = styled.button`
  position: relative;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  margin: 0;
  width: 25px;
  height: 20px;
  border-top: 2px solid ${themevals.colors.base_800}!important; 
  border-bottom: 2px solid ${themevals.colors.base_800}!important; 
  &:before {content: ""; display: block; height: 2px; width: 100%; background: ${themevals.colors.base_800}; position: absolute; top: 7px; left: 0;}  
  display: none;
  @media (max-width: 991px)  {    
    display: block;
  } 
`;

export const LoadingWrapper = styled.div`
  background: ${theme.colors.base_100};  
  display: flex;
  flex-direction: column;
  flex-grow: 1;  
`;

export const LoginWrapper = styled.div`
  width: 100%;
  background: #000;
  transition: background 0.3s linear;
  min-height: 100%;
  display: flex;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
`;

export const LogoWrapper = styled.div`
  padding: 5px;
  min-height: 100px;   
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: .5rem;
  border-bottom:1px solid #313131;    
  & img { 
    height: auto;
    max-height: 25px;
    width: 100px; 
    max-width: 100%;
  }
`;

export const LinkWrapper = styled.div`
  width: 100%;
  margin-bottom: 10px;
`;

export const NavSubLinkWrapper = styled.div`
  width: 100%;
  margin-bottom: 6px;
  padding-left: 18px;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    left: 8px;
    top: 0;
    bottom: 0;
    width: 1px;
    background: #313131;
  }
`;

export const NavSubtitle = styled.div<CustomProps>`
  color: #7D7D7D;
  font-size: 12px;
  font-weight: 400;
  font-family: "Rubik";
  margin-bottom: 10px;
  padding-left:5px;
  margin-top: ${(props) => props.$mt};
`;

export const MobilePageWrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  background: ${theme.colors.black};
  display: flex;
  flex-direction: column;
  padding: 0;
  > * {
    flex: 1;
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  @media (min-width: 768px) {
    justify-content: center;
    align-items: center;
    padding: 40px 0;
    background: ${theme.colors.black};
    padding-top: 40px;
    padding-right: 0;
    padding-bottom: 40px;
    padding-left: 0;

    > * {
      width: 390px;
      min-height: 844px;
      max-height: 90vh;
      background: ${theme.colors.white};
      box-shadow: 0 24px 48px rgba(20, 24, 35, 0.18);
      border-radius: 32px;
      overflow: hidden;
    }
  }
`;
